<template lang="pug">
.staff-form
  v-form(v-model="valid")
    v-container
      v-layout(wrap)
        v-flex(xs12
          md6)
          v-text-field(v-model="data.name"
            :rules="[v => !!v || '請填入姓名']"
            label="姓名"
            required)
        v-flex(xs12
          md6)
          v-text-field(v-model="data.job"
            label="職稱")
        v-flex(xs12
          md6)
          v-text-field(v-model="data.address"
            label="地址")
        v-flex(xs12
          md6)
          v-text-field(v-model="data.telNumber"
            label="電話")
        v-flex(xs12
          md6)
          v-text-field(v-model="data.phoneNumber"
            label="手機")
        v-flex(xs12
          md6)
          v-text-field(v-model="data.email"
            label="email")
        v-flex(xs12
          md6)
          v-text-field(v-model="data.homeland"
            label="homeland")  
      form-actions          
</template>

<script>
import each from "lodash/each";
import FormActions from "@/components/core/FormActions.vue";

export default {
  name: "StaffForm",
  components: {
    FormActions
  },
  data() {
    return {
      valid: false,
      data: {
        name: "",
        job: "",
        address: "",
        telNumber: "",
        phoneNumber: "",
        career: "",
        email: "",
        homeland: ""
      }
    };
  },
  methods: {
    setData(nData) {
      each(this.data, (v, k) => {
        if (nData.hasOwnProperty(k)) {
          v = nData[k];
        }
      });
    }
  }
};
</script>
